import { Button, Td, Tr } from "@chakra-ui/react";
import { format } from "date-fns";
import { AlertDelete } from "./AlertDelete";
import { Aprovar } from "./Aprovar";

function maskPhone(value) {
  return value.replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3')
}

export function Row({ curriculo }) {
  return (
    <Tr key={curriculo.id}>
      <Td>
        {format(new Date(curriculo.data_envio), 'dd/MM/yyyy HH:mm')}
      </Td>
      <Td>{curriculo.nome_candidato}</Td>
      <Td>{maskPhone(curriculo.telefone_candidato)}</Td>
      <Td>{curriculo.email_candidato}</Td>
      <Td>
        <Button 
          colorScheme="blue" 
          size="sm"
          as="a"
          href={curriculo.curriculo_candidato}
          target="_blank"
        >
          Visualizar
        </Button>

      </Td>
      <Td display="flex" alignItems="center" justifyContent="center" gap={2} textAlign="end">
        <Button 
          colorScheme="green" 
          size="sm"
          as="a"
          href={`https://api.whatsapp.com/send?phone=55${curriculo.telefone_candidato}`}
          target="_blank"
        >
          Enviar mensagem
        </Button> 
        <Aprovar
          id={curriculo.id_candidato}
          isApproved={curriculo.aprovacao}
        />
        <AlertDelete 
          id={curriculo.id_candidato}
          isApproved={curriculo.aprovacao}
        />
      </Td>
    </Tr>
  )
}